// extracted by css-extract-rspack-plugin
export default {"cls1":"SavedReferencesModal-cls1_hL5","cls2":"SavedReferencesModal-cls2_ahm SavedReferencesModal-cls1_hL5"};